import React from 'react'
import { useAppSelector } from 'reduxTyped'

import { getPermissions, PermissionTargets } from 'common/userRoles/selectors/userRolesSelectors'

const Permissions = ({
  children,
  target,
}: {
  children: (arg1: boolean | Record<string, boolean>) => void
  target?: PermissionTargets
}) => {
  const permissions = useAppSelector(getPermissions)
  const permission = target ? permissions[target] : permissions
  return <>{children(permission)}</>
}

export default Permissions
